import React, { ReactNode } from 'react';

export enum StatusTrackerStatus {
  'Error' = 'error',
  'Completed' = 'completed',
  'Pending' = 'pending',
  'Scheduled' = 'scheduled',
}

// progress can only be in increments of 5 to prevent overlapping circles
export type ProgressOptions =
  | 0
  | 5
  | 10
  | 15
  | 20
  | 25
  | 30
  | 35
  | 40
  | 45
  | 50
  | 55
  | 60
  | 65
  | 70
  | 75
  | 80
  | 85
  | 90
  | 95
  | 100;

// events can only be in increments of 20 to prevent overlapping labels
export type EventPositionOptions = 20 | 40 | 60 | 80;

export interface StatusTrackerEvent {
  label: string;
  date: string;
  position: EventPositionOptions;
}

export interface StatusTrackerProps {
  status?: StatusTrackerStatus;
  progress?: ProgressOptions;
  events?: StatusTrackerEvent[];
  submitted?: string;
  finished?: string;
  submittedLabel?: string;
  finishedLabel?: string;
  finishNote?: ReactNode;
  footerNote?: ReactNode;
  /** Rendered inside the Status section (card), above the status label and progress bar */
  banner?: ReactNode;
}
